import { render, staticRenderFns } from "./RequestPlaceholder.vue?vue&type=template&id=f7fbbaf0&"
import script from "./RequestPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./RequestPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./RequestPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports